import { HttpError } from "_services/api/HttpError";
import {
  IDescricaoProcessoFinanceiro,
  IFornecedorPF,
  IFornecedorPJ,
} from "../../interfaces/IFornecedor";
import { FormAcaoFornecedor } from "../FormAcaoFornecedor";
import { Container } from "./style";
import { IData } from "_services/api/interface/HttpResponse";
import { HttpResponse } from "_services/api/HttpResponse";
import { IOptions } from "components/DropdownSelect";
import { IFiltro } from "../../interfaces/IFiltro";

interface IProps {
  dados: IFornecedorPJ | IFornecedorPF | null;
  acaoFornecedor: "VER" | "ATUALIZAR" | "LISTAR" | "CADASTRAR";
  setAcaoFornecedor: (
    acaoFornecedor: "VER" | "ATUALIZAR" | "LISTAR" | "CADASTRAR"
  ) => void;
  inserirFornecedor: (
    dados: IFornecedorPF | IFornecedorPJ
  ) => Promise<HttpError<IData, any> | HttpResponse<any, any>>;
  atualizarFornecedor: (
    id: number,
    dados: IFornecedorPF | IFornecedorPJ
  ) => Promise<HttpError<IData, any> | HttpResponse<any, any>>;
  listar: (dados: IFiltro) => void;
  filtro: IFiltro;
  inserirDescricaoProcessoFinanceiroFornecedor: (
    id: number,
    dados: IDescricaoProcessoFinanceiro
  ) => Promise<HttpError<IData, any> | HttpResponse<any, any>>;
  atualizarDescricaoProcessoFinanceiroFornecedor: (
    id: number,
    idDescricaoProcessoFinanceiroFornecedor: number,
    dados: IDescricaoProcessoFinanceiro
  ) => Promise<HttpError<IData, any> | HttpResponse<any, any>>;
  excluirDescricaoProcessoFinanceiroFornecedor: (
    id: number,
    idDescricaoProcessoFinanceiroFornecedor: number
  ) => Promise<HttpError<IData, any> | HttpResponse<any, any>>;
  optionsDescricaoProcessoFinanceiro: IOptions[];
  setLoading: (loading: boolean) => void;
}

export function BodyAcaoFornecedor({
  dados,
  acaoFornecedor,
  setAcaoFornecedor,
  inserirFornecedor,
  atualizarFornecedor,
  listar,
  filtro,
  inserirDescricaoProcessoFinanceiroFornecedor,
  atualizarDescricaoProcessoFinanceiroFornecedor,
  excluirDescricaoProcessoFinanceiroFornecedor,
  optionsDescricaoProcessoFinanceiro,
  setLoading,
}: IProps) {
  return (
    <Container>
      <FormAcaoFornecedor
        dados={dados}
        acaoFornecedor={acaoFornecedor}
        setAcaoFornecedor={setAcaoFornecedor}
        optionsDescricaoProcessoFinanceiro={optionsDescricaoProcessoFinanceiro}
        inserirFornecedor={inserirFornecedor}
        atualizarFornecedor={atualizarFornecedor}
        listar={listar}
        filtro={filtro}
        inserirDescricaoProcessoFinanceiroFornecedor={
          inserirDescricaoProcessoFinanceiroFornecedor
        }
        atualizarDescricaoProcessoFinanceiroFornecedor={
          atualizarDescricaoProcessoFinanceiroFornecedor
        }
        excluirDescricaoProcessoFinanceiroFornecedor={
          excluirDescricaoProcessoFinanceiroFornecedor
        }
        setLoading={setLoading}
      />
    </Container>
  );
}
